@if (routing && (routing | shouldShowBookedRouting)) {
  <div class="routing-booked">
    <div class="routing-booked__label">{{ 'ROUTING (BOOKED)' }}</div>
    <ul class="sgl-timeline">
      @if (routing.cargoReady) {
        <li class="sgl-timeline__item">
          <span class="routing-booked__label">{{ 'CARGO READY' }}</span>
          <span class="routing-booked__value">{{ routing.cargoReady | date }}</span>
          @if (routing.cargoReady | isNotMidnight) {
            <span class="routing-booked__value--time">{{ routing.cargoReady | date: timeFormat }}</span>
          }
        </li>
      }

      @if (routing.reqEtd) {
        <li class="sgl-timeline__item">
          <span class="routing-booked__label">{{ 'REQ. ETD' }}</span>
          <span class="routing-booked__value">{{ routing.reqEtd | date }}</span>
          @if (routing.reqEtd | isNotMidnight) {
            <span class="routing-booked__value--time">{{ routing.reqEtd | date: timeFormat }}</span>
          }
        </li>
      }

      @if (routing.reqEta) {
        <li class="sgl-timeline__item">
          <span class="routing-booked__label">{{ 'REQ. ETA' }}</span>
          <span class="routing-booked__value">{{ routing.reqEta | date }}</span>
          @if (routing.reqEta | isNotMidnight) {
            <span class="routing-booked__value--time">{{ routing.reqEta | date: timeFormat }}</span>
          }
        </li>
      }
    </ul>
  </div>
}
